import { adminApiFetch } from './apiService';

export const workflowService = {
  // 列表
  fetchList: async () => {
    const response = await adminApiFetch('workflows.json', { method: 'GET' });
    return response.json();
  },

  getRecords: async () => {
    const response = await adminApiFetch('workflows');
    return response.json();
  },

  get: async (id) => {
    const response = await adminApiFetch(`workflows/${id}`);
    return response.json();
  },
  create: async (data) => {
    const response = await adminApiFetch('workflows', {
      method: 'POST',
      body: JSON.stringify({ workflow: data })
    });
    return response.json();
  },
  update: async (id, data) => {
    const response = await adminApiFetch(`workflows/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ workflow: data })
    });
    return response.json();
  },
  delete: async (id) => {
    const response = await adminApiFetch(`workflows/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },
  aiChat: async (data) => {
    const response = await adminApiFetch('workflows/ai_chat', {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return response.json();
  }
};

export default workflowService;
